import request from '@/utils/request'

export function getMsgList (data, type) {
  // get url, post json
  return request({
    url: '/api/v1/msgTemplates/search_list/' + type,
    method: 'POST',
    data
  })
}

export function getListByName (data, type, name) {
  // get url, post json
  return request({
    url: '/api/v1/msgTemplates/search/' + type + '/' + name,
    method: 'POST',
    data
  })
}

export function getOneById (data) {
  // get url, post json
  return request({
    url: '/api/v1/msgTemplates/' + data,
    method: 'GET'
  })
}

export function getOneByUniqueName (data, name) {
  // get url, post json
  return request({
    url: '/api/v1/msgTemplates/search_unique_name/' + name,
    method: 'POST',
    data
  })
  // return null
}

export function insertListById (data) {
  return request({
    url: '/api/v1/msgTemplates',
    method: 'POST',
    data
  })
}
